import React, { useState } from 'react'

import { useAsyncEffect } from '@hooks/index'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

interface Props {
  itemName: string
}

const ContentItem: React.FC<Props> = ({ itemName }: Props) => {
  const [html, setHtml] = useState<string | null>(null)

  useAsyncEffect(async (isActive) => {
    const [resp] = await http.get(ApiRoutes.contentItemPath(itemName), {
      headers: {
        Accept: 'text/plain',
      },
    })

    if (resp?.data && isActive()) setHtml(resp.data)
  }, [])

  if (!html) return null
  return <div dangerouslySetInnerHTML={{ __html: html }}></div>
}

export default ContentItem
